/* ラジオボタン */
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import { KeyValue } from '../types/KeyValue';
import Messages from '../molecules/Messages';

interface Props {
  id: string;
  label: string;
  need?: boolean;
  sources: Array<KeyValue>;
  name: string;
  value: string;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  help_msg?: string;
  disabled: boolean;
  handleBlur?: VoidFunction;
}

const RadioButton: React.FC<Props> = ({
  id,
  label,
  need,
  sources,
  name,
  value,
  handleChange,
  message,
  help_msg,
  disabled,
  handleBlur,
}) => {
  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      content={
        <>
          <InputGroup>
            {sources.map((src, index) => {
              return (
                <label className="radio-label" key={src.key}>
                  <Form.Check
                    id={`${id}-${index}`}
                    type="radio"
                    inline
                    value={src.key}
                    name={name}
                    defaultChecked={src.key === value}
                    onChange={handleChange}
                    disabled={disabled}
                    onBlur={handleBlur}
                    className="radio-button"
                  />
                  {src.value}
                </label>
              );
            })}
          </InputGroup>
          {disabled || <Messages help_msg={help_msg} valid_msg={message} />}
        </>
      }
    />
  );
};

export default RadioButton;
